import TipsMessage from '@/components/Tips.vue';

import { createApp } from 'vue';

export default {
  install: (app) => {
    const instance = createApp(TipsMessage).mount(
      document.createElement('div')
    );
    document.body.appendChild(instance.$el);
    
    app.config.globalProperties.$tipsMessage = (visible, type=1, title='', content='', update, cbtn) => {
      instance.cbtn = cbtn;
      instance.tipsVisible = visible;
      instance.title = title;
      instance.type = type;
      instance.content = content;
      instance.confirm = update;
    };
  }
};